import React from 'react';
// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import {
     Form, FormGroup, Label,
    Col,
    Container, Row
} from 'reactstrap';

import SelectListComponent from '../utils/selectList';
import DateSelector from '../utils/dateSelector';

const MatchPaymentPanel = ({ processFiles, onSearch, FileId, invoiceDate, handleSelectChange, handleChange, handleDateChange }) => {

    return (
        <Form onSubmit={e => e.preventDefault()}>
            <Container>
                <Row>
                    <Col sm="5">
                        <FormGroup className="mb-5">
                            <Label>Process</Label>
                            <SelectListComponent data={processFiles} valueKey='FileId' textField='ProcessName' selectValue={FileId} onValueChange={ (event) => handleSelectChange(event, 'FileId') } />
                        </FormGroup>
                    </Col>
                    <Col sm="5">
                        <FormGroup className="mb-5">
                            <Label>Invoice Date</Label>
                            <DateSelector dayNotAllowed={true} maxDate={new Date()} todayDate={(new Date()).toString()} onValueChange={(event) => handleDateChange(event)} />
                        </FormGroup>
                    </Col>
                    {/*<Col sm="2">
                        <label>&nbsp;</label> <br/>
                        <Button className="btn-avi-primary" onClick={() => onSearch(1)}>Reset</Button>
                    </Col>*/}
                </Row>
            </Container>

        </Form>
    )
};
export default MatchPaymentPanel;



// WEBPACK FOOTER //
// ./src/views/matchPayment/match-payment-panel.js